import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import { Wrapper } from './styles';
import { CalmLogoColor, CalmLogoProps } from './types';

const ASPECT_RATIO = 216 / 84;

const CalmLogo = ({
	className,
	height = 40,
	href = '/',
	color = CalmLogoColor.White,
	loader,
	preserveQueryParams = true,
	'aria-label': ariaLabel = 'Calm Logo - Link to Homepage',
}: CalmLogoProps): ReactElement => {
	const query = useRouter()?.query;
	const linkHref = preserveQueryParams ? { pathname: href, query } : href;
	const width = height * ASPECT_RATIO;
	const src =
		color === CalmLogoColor.White ? '/_n/images/calm-logo.svg' : '/_n/images/calm-logo-gradient.svg';
	return (
		<Wrapper className={className} $height={height} href={linkHref} aria-label={ariaLabel}>
			<Image width={width} height={height} src={src} loader={loader} alt="Calm logo" unoptimized />
		</Wrapper>
	);
};
export default CalmLogo;
